import React, {
  useEffect,
  //  useContext
} from 'react';

import DropDownDisabled from '../../../Reutilizaveis/DropDownDisabled';

import DropDown from '../../../Reutilizaveis/DropDown';

// import { ContextSolicitacoes } from "../../../../services/solicitacoes";

const Imoveis = ({
  loadImoveisDisponiveis,
  listaDeImoveis,
  setImovelSolicitacao,
  imovelSolicitacao,
  loadingImoveis,
}) => {
  // const {
  //   loadImoveisDisponiveis,
  //   listaDeImoveis,
  //   setImovelSolicitacao,
  //   imovelSolicitacao,
  //   loadingImoveis,
  // } = useContext(ContextSolicitacoes);

  useEffect(() => {
    loadImoveisDisponiveis();

    return () => {
      setImovelSolicitacao('');
    };
  }, []);

  return (
    !loadingImoveis && (
      <div style={{ marginBottom: '60px' }}>
        {listaDeImoveis?.length == 0 ? (
          <DropDownDisabled obrigatorio={true}>
            <span>Sem imóvel</span>
          </DropDownDisabled>
        ) : (
          <>
            {listaDeImoveis?.length > 1 ? (
              <DropDown
                itens={listaDeImoveis}
                idDropDown={'Listaimoveis'}
                setValue={setImovelSolicitacao}
                label='Imóvel'
                nomeDropDown='SELECIONE O IMÓVEL DESEJADO'
                obrigatorio='true'
                overflow='hidden'
                alturaMinima='120px'
                widthMeuImovel='100%'
                marginLeftMeuImovel='0px'
                nomeSelecionado={imovelSolicitacao}
              />
            ) : (
              <DropDownDisabled
                nomeDropDown='SELECIONE O IMÓVEL DESEJADO'
                obrigatorio={true}
                largura='100%'
                margin='24px 0px 0px 0px'
              >
                {listaDeImoveis?.length > 0 && listaDeImoveis[0]?.nome}
              </DropDownDisabled>
            )}
          </>
        )}
      </div>
    )
  );
};

export default Imoveis;
